import { apiRequest } from './client.js';
import type { DeviceCommand, DeviceCommandType } from '@hisob/types';
import type { CursorPaginatedResult } from '../types/index.js';

export interface CreateCommandPayload {
  type: DeviceCommandType;
  expires_in: number;
  reason: string;
  payload?: Record<string, unknown>;
}

export async function fetchCommands(params?: {
  limit?: number;
  cursor?: string;
  deviceId?: string;
  status?: string;
}): Promise<CursorPaginatedResult<DeviceCommand>> {
  return apiRequest<CursorPaginatedResult<DeviceCommand>>('/api/v1/admin/commands', { params });
}

export async function createDeviceCommand(
  deviceId: string,
  payload: CreateCommandPayload
): Promise<DeviceCommand> {
  return apiRequest<DeviceCommand>(`/api/v1/admin/devices/${deviceId}/commands`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function cancelCommand(commandId: string): Promise<{ success: boolean }> {
  return apiRequest<{ success: boolean }>(`/api/v1/admin/commands/${commandId}/cancel`, {
    method: 'POST',
  });
}

